/* =================================================================
   Shop Bitcoin Australia, "Hats, Hoodies & Hashrate" theme
   Real Shopify AJAX cart + the design's live flourishes.
   ================================================================= */
(function(){
  const $ = s => document.querySelector(s);
  try{ var _s=localStorage.getItem('sba-theme'); document.documentElement.setAttribute('data-theme', _s || (window.matchMedia&&matchMedia('(prefers-color-scheme: light)').matches?'light':'dark')); }catch(e){}
  const SBA = window.SBA || {};
  // CoinOS backend: same-origin when served from the pay host; cross-origin (PU) on the published store
  const COAPI = location.hostname === 'pay.shopbitcoin.com.au' ? '' : 'https://pay.shopbitcoin.com.au';
  let BTC_AUD = SBA.btcAud || 90700;
  // Bitcoin-payment discount, as a fraction (0.10 = 10% off). The backend
  // (sba-pay /api/coinos/rate) is the single source of truth — it both reports
  // this here for the displayed sats price AND applies it to the real draft
  // order / Lightning invoice, so display and charge never drift. 0 = off.
  let BTC_DISC = 0;
  let lastTotalCents = 0;
  // use the SAME live BTC/AUD rate the CoinOS invoice is minted at, so the
  // displayed "≈ sats" everywhere matches what the customer actually pays.
  // Retry with backoff so a transient pay-backend hiccup doesn't leave the page on the
  // stale reference rate; up to 4 tries over ~9s, then quietly keep settings.btc_aud.
  (function loadRate(attempt){
    fetch(COAPI+'/api/coinos/rate').then(r=>{ if(!r.ok) throw 0; return r.json(); }).then(d=>{
      if(d && d.btc_aud){ BTC_AUD = d.btc_aud; }
      if(d && typeof d.discount_pct === 'number'){ BTC_DISC = Math.max(0, Math.min(0.9, d.discount_pct/100)); }
      paintSats(); paintDiscBadge(); refresh();
    }).catch(()=>{ if(attempt < 4) setTimeout(()=>loadRate(attempt+1), attempt*1500); });
  })(1);

  /* ---------- money / sats helpers ---------- */
  function fmtMoney(cents){
    const v = (cents/100);
    return '$' + v.toLocaleString(undefined,{minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits:2});
  }
  // Sats preview: apply the Bitcoin-pay discount, then round UP to the nearest
  // 100 sats for clean headline numbers.
  function satsNum(cents){
    const raw = (cents/100) * (1 - BTC_DISC) / BTC_AUD * 1e8;
    return Math.max(100, Math.ceil(raw/100)*100);
  }
  function sats(cents){ return satsNum(cents).toLocaleString(); }
  // " (10% off!)" tag appended next to a sats price when the discount is live.
  function discTag(){ return BTC_DISC > 0 ? ' (' + Math.round(BTC_DISC*100) + '% off!)' : ''; }
  // Add/refresh/remove the "(N% off!)" tag inside the <small> wrapping a .sats span.
  function applyDiscTag(span){
    const host = span && span.parentNode;
    if(!host) return;
    let tag = host.querySelector('.sats-off');
    if(BTC_DISC > 0){
      if(!tag){ tag = document.createElement('span'); tag.className = 'sats-off'; host.appendChild(tag); }
      tag.textContent = discTag();
    } else if(tag){ tag.remove(); }
  }
  // Highlight the cart drawer's "Pay with Bitcoin" button with the live discount.
  function paintDiscBadge(){
    const b = document.getElementById('btcOffBadge');
    if(!b) return;
    if(BTC_DISC > 0){ b.textContent = Math.round(BTC_DISC*100) + '% off'; b.hidden = false; }
    else { b.textContent = ''; b.hidden = true; }
  }

  /* paint sats under every price on the page */
  function paintSats(root){
    (root||document).querySelectorAll('.sats[data-cents]').forEach(el=>{
      el.textContent = sats(+el.dataset.cents);
      applyDiscTag(el);
    });
  }
  paintSats();

  /* ---------- cart drawer ---------- */
  const drawer = $('#cartDrawer'), overlay = $('#cartOverlay');
  const itemsEl = $('#cartItems'), countEl = $('#cartCount'),
        totalEl = $('#cartTotal'), satsEl = $('#cartSats'), checkoutBtn = $('#checkoutBtn'), btcBtn = $('#btcCheckoutBtn');
  function openCart(){ drawer.classList.add('open'); overlay.classList.add('open'); }
  function closeCart(){ drawer.classList.remove('open'); overlay.classList.remove('open'); }
  $('#cartBtn') && $('#cartBtn').addEventListener('click', e=>{ e.preventDefault(); openCart(); });
  $('#cartClose') && $('#cartClose').addEventListener('click', closeCart);
  overlay && overlay.addEventListener('click', closeCart);
  addEventListener('keydown', e=>{ if(e.key==='Escape') closeCart(); });
  // Umami funnel: standard Shopify checkout intent (BTC checkout is tracked separately below).
  checkoutBtn && checkoutBtn.addEventListener('click', ()=>{ try{ window.umami&&window.umami.track('begin_checkout',{method:'standard'}); }catch(_){} });

  function renderCart(cart){
    const count = cart.item_count;
    if(countEl){
      countEl.textContent = count;
      countEl.style.transform='scale(1.4)'; setTimeout(()=>countEl.style.transform='',150);
    }
    lastTotalCents = cart.total_price;
    if(totalEl) totalEl.textContent = fmtMoney(cart.total_price);
    if(satsEl) satsEl.textContent = '≈ '+sats(cart.total_price)+' sats'+discTag();
    if(checkoutBtn) checkoutBtn.classList.toggle('disabled', count===0);
    if(btcBtn) btcBtn.classList.toggle('disabled', count===0);
    if(!itemsEl) return;
    itemsEl.innerHTML = cart.items.length ? cart.items.map(i=>`
      <div class="ci">
        <span class="ci-emoji">${i.image ? `<img src="${i.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_120x$1')}" alt="">` : ''}</span>
        <div class="ci-info">
          <div class="ci-name">${i.product_title}</div>
          <div class="ci-price">${fmtMoney(i.final_price)} × ${i.quantity}</div>
        </div>
        <div class="ci-qty">
          <button data-key="${i.key}" data-q="${i.quantity-1}">−</button>
          <span>${i.quantity}</span>
          <button data-key="${i.key}" data-q="${i.quantity+1}">+</button>
        </div>
      </div>`).join('')
      : `<p class="cart-empty">Your bag's emptier than a no-coiner's wallet.<br>Add some gear</p>`;
  }

  function getCart(){ return fetch(SBA.routes.cart, {headers:{'Accept':'application/json'}}).then(r=>r.json()); }
  function refresh(){ getCart().then(renderCart).catch(()=>{ if(checkoutBtn) checkoutBtn.classList.remove('disabled'); if(btcBtn) btcBtn.classList.remove('disabled'); }); }

  /* add to cart */
  document.addEventListener('click', e=>{
    const btn = e.target.closest('[data-add-to-cart]');
    if(!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId;
    // optimistic feedback so it feels instant, swap the circular plus for a tick
    const plus = btn.querySelector('.card-buy-plus');
    if(plus && !plus._html){
      plus._html = plus.innerHTML;
      btn.classList.add('is-added');
      plus.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      setTimeout(()=>{ btn.classList.remove('is-added'); plus.innerHTML = plus._html; plus._html = null; }, 1400);
    }
    btn.disabled = true;
    fetch(SBA.routes.cartAdd, {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id:Number(id), quantity:1 }] })
    }).then(r=>r.json()).then(()=>{
      try{ window.umami&&window.umami.track('add_to_cart',{variant_id:Number(id),name:btn.dataset.name||''}); }catch(_){}
      toast('Added, '+(btn.dataset.name||'item'));
      openCart(); refresh();
    }).catch(()=>{}).finally(()=>{ btn.disabled=false; });
  });

  /* change qty (delegated, drawer is re-rendered) */
  itemsEl && itemsEl.addEventListener('click', e=>{
    const b = e.target.closest('button[data-key]');
    if(!b) return;
    fetch(SBA.routes.cartChange, {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id:b.dataset.key, quantity:Number(b.dataset.q) })
    }).then(r=>r.json()).then(renderCart);
  });

  refresh();

  /* ---------- standard Bitcoin checkout overlay (cart-collected, BTC-settled) ---------- */
  const coOverlay = $('#coOverlay'), coForm = $('#coForm');
  let coPoll = null, coCart = null;
  function coClose(){ if(!coOverlay) return; coOverlay.classList.remove('open'); coOverlay.setAttribute('aria-hidden','true'); document.body.style.overflow=''; if(coPoll){ clearInterval(coPoll); coPoll=null; } }
  $('#coClose') && $('#coClose').addEventListener('click', coClose);
  // recalculate live shipping when the address changes (debounced)
  ['coAddr1','coCity','coZip','coProv','coCountry'].forEach(id=>{
    const el=$('#'+id);
    el && el.addEventListener('change', ()=>{ if(!coOverlay) return; clearTimeout(coOverlay._shipT); coOverlay._shipT=setTimeout(calcShipping,250); });
  });

  function renderSummary(cart){
    coCart = cart;
    $('#coItems').innerHTML = cart.items.map(i=>{
      const img = i.image ? i.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_120x$1') : '';
      const vt = (i.variant_title && i.variant_title!=='Default Title') ? '<small>'+i.variant_title+'</small>' : '';
      return `<div class="co-item"><span class="co-item-img">${img?`<img src="${img}" alt="">`:''}<b>${i.quantity}</b></span><span class="co-item-name">${i.product_title}${vt}</span><span class="co-item-price">${fmtMoney(i.final_line_price)}</span></div>`;
    }).join('');
    coOverlay._shipPrice = 0; coOverlay._shipQuoted = false; coOverlay._shipHandle = null;
    coOverlay._shipMsg = 'Enter address to calculate';
    setShipRow('<span class="co-radio-label">Shipping</span><span class="co-radio-price">Enter address to calculate</span>');
    updateCoTotals();
    calcShipping();
  }
  function updateCoTotals(){
    const sub = coCart ? coCart.total_price : 0;
    const ship = coOverlay._shipQuoted ? (coOverlay._shipPrice||0) : 0;
    const total = sub + ship;
    $('#coSub').textContent = fmtMoney(sub);
    $('#coShipCost').textContent = coOverlay._shipQuoted ? fmtMoney(ship) : (coOverlay._shipMsg||'Quoted separately');
    $('#coTotal').textContent = fmtMoney(total);
    $('#coTotalSats').textContent = '≈ '+sats(total)+' sats'+discTag();
    coOverlay._totalCents = total;
  }
  function setShipRow(html){ const r=$('#coShipRow'); if(r) r.innerHTML=html; }
  function renderRates(rates){
    rates = rates.slice().sort((a,b)=>a.price-b.price);
    const sel = (coOverlay._shipHandle && rates.find(r=>r.handle===coOverlay._shipHandle)) || rates[0];
    if(rates.length===1){
      setShipRow('<span class="co-radio-label">'+rates[0].title+'</span><span class="co-radio-price">'+fmtMoney(rates[0].price*100)+'</span>');
    } else {
      setShipRow(rates.map(r=>'<label class="co-ship-opt"><input type="radio" name="coShip" value="'+r.handle+'"'+(r.handle===sel.handle?' checked':'')+'><span class="co-ship-name">'+r.title+'</span><span class="co-radio-price">'+fmtMoney(r.price*100)+'</span></label>').join(''));
      document.querySelectorAll('input[name=coShip]').forEach(inp=>inp.addEventListener('change',()=>{
        const r=rates.find(x=>x.handle===inp.value); if(!r) return;
        coOverlay._shipHandle=r.handle; coOverlay._shipTitle=r.title; coOverlay._shipPrice=Math.round(r.price*100); updateCoTotals();
      }));
    }
    coOverlay._shipHandle=sel.handle; coOverlay._shipTitle=sel.title; coOverlay._shipPrice=Math.round(sel.price*100);
    coOverlay._shipQuoted=true; updateCoTotals();
  }
  async function calcShipping(){
    if(coOverlay._demo || !coCart || !coCart.items || !coCart.items.length) return;
    const ship={ zip:$('#coZip').value, province:$('#coProv').value, country:$('#coCountry').value,
                 address1:$('#coAddr1').value, city:$('#coCity').value };
    if(!ship.address1 || !ship.city || !ship.zip || !ship.country) return;
    coOverlay._shipQuoted=false; coOverlay._shipMsg='Calculating…';
    setShipRow('<span class="co-radio-label">Shipping</span><span class="co-radio-price">Calculating…</span>'); updateCoTotals();
    try{
      // Use the SAME storefront shipping rates the regular cart/checkout shows (Tracked Postage, Express…).
      const qs='shipping_address[zip]='+encodeURIComponent(ship.zip)+'&shipping_address[country]='+encodeURIComponent(ship.country)+'&shipping_address[province]='+encodeURIComponent(ship.province||'');
      const r=await fetch('/cart/shipping_rates.json?'+qs,{headers:{'Accept':'application/json'}});
      if(!r.ok) throw new Error('http');
      const d=await r.json();
      const rates=(d.shipping_rates||[]).map(x=>({handle:x.code||x.name, title:x.name, price:parseFloat(x.price)})).filter(x=>!isNaN(x.price));
      if(!rates.length){ coOverlay._shipQuoted=false; coOverlay._shipHandle=null; coOverlay._shipTitle=null; coOverlay._shipPrice=0; coOverlay._shipMsg='No delivery to this address';
        setShipRow('<span class="co-radio-label">Shipping</span><span class="co-radio-price">No delivery to this address</span>'); updateCoTotals(); return; }
      renderRates(rates);
    }catch(_){ coOverlay._shipQuoted=false; coOverlay._shipHandle=null; coOverlay._shipTitle=null; coOverlay._shipPrice=0; coOverlay._shipMsg='Calculated at checkout';
      setShipRow('<span class="co-radio-label">Shipping</span><span class="co-radio-price">Calculated at checkout</span>'); updateCoTotals(); }
  }

  async function coOpen(){
    let cart=null; try{ cart=await (await fetch(SBA.routes.cart)).json(); }catch(_){}
    if(!cart || !cart.items || !cart.items.length){ cart={items:[{product_title:'Sample item',variant_title:'Preview',quantity:1,final_line_price:2100,image:''}],total_price:2100,item_count:1}; coOverlay._demo=true; }
    else coOverlay._demo=false;
    renderSummary(cart);
    coOverlay._submitting=false;
    $('#coPay').hidden=true; $('#coPayNow').style.display=''; $('#coPayNow').disabled=false; $('#coPayNow').textContent='Place order & pay';
    $('#coStatus').textContent='Waiting for payment…'; $('#coStatus').className='co-pay-status';
    coOverlay.classList.add('open'); coOverlay.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden';
  }

  document.addEventListener('click', e=>{
    const b=e.target.closest('[data-checkout]'); if(!b) return; e.preventDefault();
    try{ window.umami&&window.umami.track('begin_checkout',{method:'bitcoin'}); }catch(_){}
    if(!coOverlay){ if(b.dataset.fallback) window.open(b.dataset.fallback,'_blank'); return; }
    coOverlay._fallback=b.dataset.fallback; coOpen();
  });

  coForm && coForm.addEventListener('submit', async e=>{
    e.preventDefault();
    if(coOverlay._submitting) return;        // guard against double-click / double-submit
    if(!coForm.reportValidity()) return;
    const email=$('#coEmail').value.trim(), phone=$('#coPhone').value.trim();
    if(!email && !phone){ toast('Add an email or mobile so we can send your receipt & postage updates'); $('#coEmail').focus(); return; }
    coOverlay._submitting=true;
    const method = ((coForm.querySelector('input[name=paymethod]:checked')||{}).value)||'lightning';
    const estSats = satsNum(coOverlay._totalCents);   // sats estimate at order time (for the price-move note)
    const payNow=$('#coPayNow'), payEl=$('#coPay'), qrEl=$('#coQr'), boltEl=$('#coBolt'), openEl=$('#coOpen'), statusEl=$('#coStatus');
    payNow.disabled=true; payNow.textContent='Creating your order…';
    const shipping={ name:$('#coName').value, address1:$('#coAddr1').value, address2:$('#coAddr2').value, city:$('#coCity').value, province:$('#coProv').value, zip:$('#coZip').value, country:$('#coCountry').value, phone:phone };
    try{
      let inv, draftId=null;
      const items = (!coOverlay._demo && coCart) ? coCart.items.map(i=>({id:i.variant_id||i.id, quantity:i.quantity})) : null;
      if(items){
        const r=await fetch(COAPI+'/api/coinos/checkout',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items, email, phone, method, shipping, shipping_title: coOverlay._shipTitle, shipping_price: (coOverlay._shipPrice||0)/100})});
        inv=await r.json(); if(!r.ok||inv.error) throw new Error(inv.error||'api'); draftId=inv.draft_id;
      } else {
        const r=await fetch(COAPI+'/api/coinos/invoice',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({amount_aud: coOverlay._totalCents/100, comment:'SBA preview'})});
        inv=await r.json(); if(!r.ok||inv.error) throw new Error(inv.error||'api');
      }
      payEl.hidden=false; payNow.style.display='none';
      // show the exact sats due + how it moved from the estimate (BTC price drifts between estimate and invoice)
      const actualSats = +inv.sats || 0, amtEl=$('#coPayAmount');
      if(amtEl && actualSats){ let amt='Pay '+actualSats.toLocaleString()+' sats'+(method==='onchain'?' on-chain':'');
        const d=actualSats-estSats; if(estSats && Math.abs(d)>=50){ amt+=' ('+(d>0?'+':'−')+Math.abs(d).toLocaleString()+' sats vs estimate)'; }
        amtEl.textContent=amt; }
      const tick='<div class="lnpay-tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></div>';
      if(method==='onchain'){
        const addr=inv.address||'';
        boltEl.textContent=addr.slice(0,16)+'…'+addr.slice(-10);
        boltEl.onclick=()=>{ navigator.clipboard&&navigator.clipboard.writeText(addr); toast('Address copied'); };
        openEl.href=inv.bip21||('bitcoin:'+addr);
        if(inv.qr) qrEl.innerHTML='<img alt="Bitcoin address QR" src="'+inv.qr+'">';
        else qrEl.innerHTML='<p class="cart-mini">Scan unavailable, copy the address or tap Open in wallet.</p>';
        statusEl.textContent='Waiting for payment…'; statusEl.className='co-pay-status';
        payEl.scrollIntoView({behavior:'smooth',block:'center'});
        coPoll=setInterval(async()=>{   // on-chain confirms slowly; poll gently
          try{ const c=await (await fetch(COAPI+'/api/coinos/onchain-status?id='+encodeURIComponent(inv.invoice_id))).json();
            if(c.settled){ clearInterval(coPoll); coPoll=null; let msg='Payment confirmed, thank you.';
              if(draftId){ try{ const o=await (await fetch(COAPI+'/api/coinos/complete',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({method:'onchain', draft_id:draftId, invoice_id:inv.invoice_id})})).json(); if(o.order_name) msg='Order '+o.order_name+' confirmed, on its way.'; }catch(_){} }
              statusEl.textContent=msg; statusEl.className='co-pay-status paid'; qrEl.innerHTML=tick;
            } else if(c.seen){ statusEl.textContent="Payment detected, confirming on-chain. You can close this page; we'll email your confirmation."; statusEl.className='co-pay-status seen'; }
          }catch(_){}
        },8000);
      } else {
        boltEl.textContent=inv.bolt11.slice(0,18)+'…'+inv.bolt11.slice(-10);
        openEl.href='lightning:'+inv.bolt11;
        boltEl.onclick=()=>{ navigator.clipboard&&navigator.clipboard.writeText(inv.bolt11); toast('Invoice copied'); };
        if(inv.qr) qrEl.innerHTML='<img alt="Lightning invoice QR" src="'+inv.qr+'">';
        else qrEl.innerHTML='<p class="cart-mini">Scan unavailable, copy the invoice or tap Open in wallet.</p>';
        statusEl.textContent='Waiting for payment…'; statusEl.className='co-pay-status';
        payEl.scrollIntoView({behavior:'smooth',block:'center'});
        coPoll=setInterval(async()=>{
          try{ const c=await (await fetch(COAPI+'/api/coinos/check?verify='+encodeURIComponent(inv.verify))).json();
            if(c.settled){ clearInterval(coPoll); coPoll=null; let msg='Payment received, thank you.';
              if(draftId){ try{ const o=await (await fetch(COAPI+'/api/coinos/complete',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({draft_id:draftId, verify:inv.verify})})).json(); if(o.order_name) msg='Order '+o.order_name+' confirmed, on its way.'; }catch(_){} }
              statusEl.textContent=msg; statusEl.className='co-pay-status paid'; qrEl.innerHTML=tick;
            }
          }catch(_){}
        },3000);
      }
    }catch(err){ coOverlay._submitting=false; payNow.disabled=false; payNow.textContent='Place order & pay'; if(coOverlay._fallback) window.open(coOverlay._fallback,'_blank'); }
  });
  // payment-method selector: highlight choice + swap the explanatory note
  const CO_NOTES={
    lightning:"After you place the order we'll show a Lightning invoice. Scan it with any Bitcoin wallet and you're done in seconds.",
    onchain:"After you place the order we'll show a Bitcoin address and QR. Send the exact amount from any on-chain wallet; we confirm once it's in a block (about 10 to 60 minutes) and email your receipt."
  };
  coForm && coForm.querySelectorAll('input[name=paymethod]').forEach(r=>r.addEventListener('change',()=>{
    const m=r.value, note=$('#coMethodNote');
    if(note) note.textContent=CO_NOTES[m]||CO_NOTES.lightning;
    coForm.querySelectorAll('.co-method-sel').forEach(el=>el.classList.toggle('sel', el.dataset.method===m));
  }));

  addEventListener('keydown', e=>{ if(e.key==='Escape') coClose(); });

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg){
    const el = $('#toast'); if(!el) return;
    const clean = msg.length > 42 ? msg.slice(0,40).trimEnd()+'…' : msg;
    el.textContent = '✓ '+clean;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(()=>el.classList.remove('show'), 2000);
  }

  /* ---------- scroll reveal ---------- */
  const io = new IntersectionObserver(es=>{
    es.forEach(en=>{ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
  }, {threshold:0.12});
  function observeReveals(){
    document.querySelectorAll('.reveal:not(.in)').forEach(el=>io.observe(el));
    document.querySelectorAll('.card:not([data-rev]),.why-card:not([data-rev]),.t-card:not([data-rev]),.eco-card:not([data-rev])').forEach((el,i)=>{
      el.dataset.rev=1; el.classList.add('reveal'); el.style.transitionDelay=(i%4*55)+'ms'; io.observe(el);
    });
  }
  observeReveals();

  /* ---------- nav scroll ---------- */
  /* Mobile menu / burger / nav-trigger toggling lives in an inline <head> script in
     layout/theme.liquid so it's interactive before this deferred file loads. Don't
     re-wire it here — a second click handler would double-toggle (net no-op). */
  const nav = $('#nav');
  nav && addEventListener('scroll', ()=> nav.classList.toggle('scrolled', scrollY>20));

  /* ---------- light / dark toggle ---------- */
  const themeToggle = $('#themeToggle');
  themeToggle && themeToggle.addEventListener('click', ()=>{
    const next = (document.documentElement.getAttribute('data-theme')||'dark') === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    try{ localStorage.setItem('sba-theme', next); }catch(e){}
  });

  /* ---------- miner live readout (over the Bitaxe image) ---------- */
  const ths=$('#thsReadout'),temp=$('#tempReadout'),watt=$('#wattReadout');
  if(ths||temp||watt){
    setInterval(()=>{ if(ths)ths.textContent=(1.15+Math.random()*0.12).toFixed(2);
      if(temp)temp.textContent=52+Math.floor(Math.random()*5);
      if(watt)watt.textContent=14+Math.floor(Math.random()*3); },1400);
  }

  /* ---------- PDP variant swatches (replaces the long dropdown) ---------- */
  const pdpV = $('#pdpVariants');
  if(pdpV){
    const raw = (document.getElementById('pdpVariantData').textContent||'').trim().split('|');
    let ids, opts, avail, prices, imgs, fulfil;
    try { ids=JSON.parse(raw[0]); opts=JSON.parse(raw[1]); avail=JSON.parse(raw[2]); prices=JSON.parse(raw[3]); imgs=raw[4]?JSON.parse(raw[4]):null; fulfil=raw[5]?JSON.parse(raw[5]):null; } catch(e){ opts=null; }
    if(opts){
      const idInput=$('#pdpVariantId'), priceEl=$('#pdpPrice'), satsEl=$('#pdpSats'),
            addBtn=$('#pdpAdd'), addLabel=$('#pdpAddLabel'), imgEl=$('#pdpImg'), fulfilNote=$('#pdpFulfilNote');
      const sel=[];
      pdpV.querySelectorAll('.pdp-opt').forEach((o,i)=>{ const on=o.querySelector('.pdp-swatch.on')||o.querySelector('.pdp-swatch'); if(on){on.classList.add('on'); sel[i]=on.dataset.value;} });
      function resolve(){
        let idx=-1;
        for(let i=0;i<opts.length;i++){ const o=opts[i]; if(o.length===sel.length && o.every((v,j)=>String(v)===String(sel[j]))){ idx=i; break; } }
        if(idx<0) return;
        idInput.value = ids[idx];
        if(priceEl) priceEl.textContent = fmtMoney(prices[idx]);
        if(satsEl){ satsEl.dataset.cents = prices[idx]; satsEl.textContent = sats(prices[idx]); applyDiscTag(satsEl); }
        if(addBtn){ const ok=!!avail[idx]; addBtn.disabled=!ok; if(addLabel) addLabel.textContent = ok ? 'Add to bag' : 'Sold out'; }
        // swap the main gallery image to the selected variant's image (if it has one)
        if(imgEl && imgs && imgs[idx]){ imgEl.src = imgs[idx]; }
        // flag overseas-fulfilled colours
        if(fulfilNote && fulfil){ fulfilNote.style.display = (fulfil[idx]==='International') ? '' : 'none'; }
      }
      pdpV.addEventListener('click', e=>{
        const sw=e.target.closest('.pdp-swatch'); if(!sw) return;
        const o=sw.closest('.pdp-opt'); const i=+o.dataset.optIndex;
        o.querySelectorAll('.pdp-swatch').forEach(b=>b.classList.remove('on'));
        sw.classList.add('on'); sel[i]=sw.dataset.value; resolve();
      });
      resolve();
    }
  }
})();
